var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 68.22581,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.23006,46.7587c0,18.90475-15.32533,34.23007-34.23007,34.23007s-34.23007-15.32533-34.23007-34.23007S56.09524,12.52862,74.99999,12.52862s34.23007,15.32533,34.23007,34.23007Zm-6.43028,35.73385c-1.5761-.6038-3.34745-.45121-4.76956.45779-6.81767,4.35781-14.74389,6.6943-23.03022,6.6943s-16.21256-2.33649-23.03022-6.6943c-1.42211-.909-3.19347-1.06162-4.76957-.45779-12.85137,4.92339-23.41131,13.15066-30.01566,23.33928-1.12419,1.73431-1.11191,3.97745.00499,5.71649,12.20927,19.01047,33.53888,31.60542,57.81049,31.60542s45.60119-12.59493,57.81046-31.60542c1.11687-1.73904,1.12918-3.98219.00499-5.71649-6.60436-10.18863-17.16427-18.41587-30.01566-23.33928h-.00004Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75,6.77419c37.68003,0,68.22581,30.54574,68.22581,68.22581s-30.54577,68.22581-68.22581,68.22581S6.77419,112.68006,6.77419,75,37.31991,6.77419,75,6.77419m0-6.77419C33.64486,0,0,33.64486,0,75s33.64486,75,75,75,75-33.64486,75-75S116.35514,0,75,0h0Z",
    fill: "#515151"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.4c2cc4eb6691fe6576d0a3b8fa61e97a.svg";
export { ForwardRef as ReactComponent };